import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { getPaginationMap } from '../utils/ApolloGraphqlUtil';
import ArrayUtil from '../utils/ArrayUtil';

export const SURVEYS_QUERY = gql`
  query surveys(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SurveyFilter
    $sort: SurveySortSpecifier
  ) {
    account(id: $accountId) {
      id
      surveys(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            createdOn
            statuses
            self {
              id
              template {
                title
              }
              respondent {
                id
                firstName
                lastName
                locale
              }
            }
          }
        }
      }
    }
  }
`;

const surveysQuery = graphql(SURVEYS_QUERY, {
  options: ({ paginationFilter, currentAccount }) => {
    const {
      pageSize, cursorEnd, pageSizeLast, cursorStart, query, tags, orderBy, orderDir,
    } = paginationFilter;
    const sort = orderBy || orderDir
      ? {
        sortBy: orderBy,
        sortDir: orderDir,
      }
      : null;
    return {
      variables: {
        accountId: currentAccount,
        first: pageSize,
        after: cursorEnd,
        last: pageSizeLast,
        before: cursorStart,
        filter: {
          query,
          tags: ArrayUtil.isNotEmpty(tags) ? tags : null,
        },
        sort,
      },
      fetchPolicy: 'network-only',
    };
  },
  props: ({ data, ownProps }) => {
    const { account, fetchMore } = data;
    const { pageSize, query, tags } = ownProps.paginationFilter;
    const { surveys } = account || { surveys: {} };

    return {
      data: {
        ...data,
        account: {
          ...account,
          surveys,
        },
        fetchMoreEntries: direction => fetchMore({
          variables: {
            pagination: getPaginationMap(surveys.pageInfo, pageSize)[direction],
            query,
            tags: ArrayUtil.isNotEmpty(tags) ? tags : null,
          },
          updateQuery: (previousResult, { fetchMoreResult }) => fetchMoreResult,
        }),
      },
    };
  },
});

export default surveysQuery;
